import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIf } from '@angular/common';

interface LinkItem {
    icon?: string;
    title: string;
    link: string[];
    exactLink?: boolean;
    hasPermission?: boolean;
    children?: LinkItem[];
}

@Component({
    selector: 'qc-context-navigation',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, NgIf],
    template: `
        <aside class="w-56 flex-shrink-0 flex flex-col bg-neutral-50 border-e border-neutral-150 min-h-dvh">
            <nav class="flex flex-col mt-8">
                <ul>
                    @for (menuItem of menuItems; track menuItem) {
                        <li class="my-1" *ngIf="menuItem.hasPermission === undefined || menuItem.hasPermission">
                            <a
                                class="flex content-center gap-3 px-8 py-2 border-s-4 border-transparent opacity-40 hover:opacity-100 transition-opacity"
                                [routerLink]="menuItem.link"
                                routerLinkActive="border-white opacity-100"
                                [routerLinkActiveOptions]="{
                                    exact: menuItem?.exactLink || false,
                                }"
                                #rla="routerLinkActive"
                            >
                                <span>{{ menuItem.title }}</span>
                            </a>
                            <ul
                                class="ms-18 me-5 mb-4 "
                                *ngIf="menuItem.children && menuItem.children.length && rla.isActive"
                            >
                                @for (menuItemChildren of menuItem.children; track menuItemChildren) {
                                    <li
                                        *ngIf="
                                            menuItemChildren.hasPermission === undefined ||
                                            menuItemChildren.hasPermission
                                        "
                                    >
                                        <a
                                            class="flex content-center py-1.5 opacity-60 hover:opacity-100 transition-opacity"
                                            [routerLink]="menuItemChildren.link"
                                            routerLinkActive="active"
                                            [routerLinkActiveOptions]="{
                                                exact: menuItemChildren?.exactLink || false,
                                            }"
                                        >
                                            {{ menuItemChildren.title }}
                                        </a>
                                    </li>
                                }
                            </ul>
                        </li>
                    }
                </ul>
            </nav>
        </aside>
    `,
})
export class ContextNavigationComponent {
    @Input() menuItems: LinkItem[] = [];
}
